export default __webpack_public_path__ + "static/media/je.939d0715.svg";